import React from "react";

const Exception = () => (
    <section data-bs-version="5.1" className="team2 cid-error-page" id="payment-error">
        <div className="container py-5" style={{paddingTop: "20rem"}}>
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-lg p-4 text-center">
                        <h3 className="mbr-section-title mbr-fonts-style text-danger display-2">
                            Ошибка при попытке оплаты
                        </h3>
                        <p className="mbr-text mbr-fonts-style display-7 mt-3">
                            Пожалуйста, попробуйте снова или обратитесь в поддержку.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

Exception.link = "/error";

export default Exception;